/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiPageHeader, EuiSpacer } from '@elastic/eui'

import Breadcrumbs from '@modules/cui/Breadcrumbs'
import { FormattedMessage } from '@modules/i18n'
import TrafficFilterSummary from '@modules/network-security-components/TrafficFilterSummary'
import TrafficFilterList from '@modules/network-security-components/TrafficFilterList'

import { networkSecurityCrumbs } from './breadcrumbs'

const NetworkSecurity: React.FunctionComponent = () => {
  const intro = (
    <FormattedMessage
      id='networkSecurity.page.intro'
      defaultMessage='Secure your Elastic Cloud resources by creating private connections, allowlisting specific VPC endpoints or filtering specific ingress or egress IP addresses or CIDR blocks. If no network security is applied to a resource, it can be accessed over the public internet.'
    />
  )

  return (
    <div>
      <Breadcrumbs breadcrumbs={networkSecurityCrumbs()} />

      <EuiPageHeader
        description={intro}
        bottomBorder={true}
        pageTitle={
          <FormattedMessage id='networkSecurity.page.title' defaultMessage='Network security' />
        }
      />

      <EuiSpacer />

      <TrafficFilterSummary />

      <EuiSpacer size='m' />

      <TrafficFilterList />
    </div>
  )
}

export default NetworkSecurity
